import { render, staticRenderFns } from "./DigitalMarketingLandingPage2.vue?vue&type=template&id=74f9d554&scoped=true&"
import script from "./DigitalMarketingLandingPage2.vue?vue&type=script&lang=js&"
export * from "./DigitalMarketingLandingPage2.vue?vue&type=script&lang=js&"
import style0 from "./DigitalMarketingLandingPage2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DigitalMarketingLandingPage2.vue?vue&type=style&index=1&id=74f9d554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9d554",
  null
  
)

export default component.exports